import { notifyError } from '~/common/notifications';
import { signOut } from '~/features/auth/store/actions.thunks';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from '~/@types/app-types';
import { Action } from 'typesafe-actions';

export const errorHandler = (e: any, dispatch: ThunkDispatch<AppState, any, Action<string>>) => {
    const errorText = e.response?.data?.message || e?.response?.data?.Message || e;
    if (e.response?.status === 401) {
        // @ts-ignore
        dispatch(signOut());
    } else {
        notifyError({
            title: 'Error',
            message: errorText.toString(),
        });
    }
    return {
        error: true,
        data: errorText,
    };
};
